import instance from '../index';

const RESOURCE_BILLINGS = 'billings';

export const BillingsApi = {
  /**
   * Get billing information
   * @returns {Promise<Object>} The billing information
   */
  getBilling() {
    return instance.get(`/${RESOURCE_BILLINGS}`);
  },

  getInvoice(subscriptionId) {
    return instance.get(`/${RESOURCE_BILLINGS}/invoice/${subscriptionId}`);
  }
};
